import * as React from 'react';
import { Key, ReactNode, useContext, useState } from 'react';
import { ImageServiceApi, UsersDTO } from '../../api/admin';
import { getAuthMiddleware } from '../../Auth/utils/GetAuthMiddleware';
import { AuthContext } from '../../Auth/components/AuthProvider';
import { Chip } from 'primereact/chip';

interface Props {
  user: UsersDTO;
  key?: Key;
}

export const UserChipComponent = (props: Props): ReactNode => {
  const {actions} = useContext(AuthContext);
  const imageApi: ImageServiceApi = new ImageServiceApi().withMiddleware(getAuthMiddleware(actions));
  const [avatarUrl, setAvatarUrl] = useState<string>(undefined);

  if (avatarUrl === undefined && props.user && props.user.id !== undefined) {
    void imageApi
      .downloadFile({ userId: props.user.id })
      .then((avatar: Blob) => setAvatarUrl(URL.createObjectURL(avatar)));
  }
  if (!avatarUrl) {
    return <Chip label={props.user ? `${props.user.givenname} ${props.user.surname}` : 'unknown'}/>;
  }
  return <Chip image={avatarUrl} label={props.user ? `${props.user.givenname} ${props.user.surname}` : 'unknown'}/>;
};
